/**
 * Determines whether the activity will have enough time to complete based on
 * current progress.
 */
export function doesActivityHaveRemainingCapacity(completedBytes, activityBandwidthVerifier) {
    var rateRatio = getRateRatio(completedBytes, activityBandwidthVerifier);
    return typeof rateRatio !== 'undefined' ? rateRatio <= 1 : true;
}
/**
 * Calculates the ratio of the required remaining rate over the current rate.
 */
function getRateRatio(completedBytes, activityBandwidthVerifier) {
    activityBandwidthVerifier.progressPoints++;
    var currentTime = performance.now();
    var elapsedDuration = currentTime - activityBandwidthVerifier.startTime;
    var remainingDuration = activityBandwidthVerifier.expirationTime - currentTime;
    var remainingBytes = activityBandwidthVerifier.totalBytes - completedBytes;
    var rateRatio = undefined;
    if (activityBandwidthVerifier.progressPoints >= 4 &&
        elapsedDuration >= 4 * 1000 &&
        remainingDuration > 0 &&
        elapsedDuration > 0) {
        rateRatio =
            remainingBytes /
                remainingDuration /
                (completedBytes / elapsedDuration);
    }
    return rateRatio;
}
//# sourceMappingURL=doesActivityHaveRemainingCapacity.js.map